import { render } from "./LocalUpdate.vue?vue&type=template&id=9253d590"
import script from "./LocalUpdate.vue?vue&type=script&lang=js"
export * from "./LocalUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__